import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import KeyValue from '../KeyValue';
import DaysTillEscalation from '../DaysTillEscalation';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { DateFormat } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { AnomalyStatus, IEstimatesDetails } from '../../types';
import { useParams } from 'react-router-dom';

const EstimatesDetails = (props: IEstimatesDetails) => {
  const { tabId = '' } = useParams();
  const { descriptionClass = '' } = props;
  const anomalyDetails = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.data
  );

  const { createdAt, estimatedTime, daysRemaining, escalationPercentage, resolution } =
    anomalyDetails || {};

  const { at, reason } = estimatedTime || {};
  const { at: resolvedAt } = resolution || {};

  const isOpenAnomalyView = tabId === AnomalyStatus.OPEN;
  return (
    <div>
      <Typography color="var(--grayscale-2)" variant="h3" className="mb-1">
        Dates & Estimates
      </Typography>
      <div className={descriptionClass}>
        <KeyValue
          title="Created on"
          description={
            createdAt ? dayjs(createdAt)?.format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME) : null
          }
          containerClass="mt-3 !mb-0"
        />
        {daysRemaining && escalationPercentage ? (
          <KeyValue
            title="Days till Escalation"
            description={
              <DaysTillEscalation
                daysTillEscalation={daysRemaining || 0}
                progressPercent={escalationPercentage || 0}
                progressTextClass={styles.progressText}
                containerClass="!w-5 !h-5"
                sqSize={24}
                strokeWidth={3}
              />
            }
            containerClass="mt-3 !mb-0 !flex !items-center"
          />
        ) : null}
        {resolvedAt ? (
          <KeyValue
            title="Resolved on"
            containerClass="mt-3 !mb-0"
            description={dayjs(resolvedAt)?.format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)}
          />
        ) : null}
        {at && isOpenAnomalyView ? (
          <KeyValue
            title="Resolution ETA"
            containerClass="mt-3 !mb-0"
            description={at ? dayjs(at)?.format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME) : null}
          />
        ) : null}
        {reason && isOpenAnomalyView ? (
          <KeyValue title="Reason for ETA" containerClass="mt-3 !mb-0" description={reason} />
        ) : null}
      </div>
    </div>
  );
};

export default EstimatesDetails;
